import React from "react";
import { CallbackComponent } from "redux-oidc";
import { push } from 'connected-react-router'
import userManager from "../utils/userManager";
import { Typography } from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';
import { connect } from "react-redux";

const styles = theme => ({
  root: {
    padding: 16,
    margin: 16
  }
});


class CallbackPage extends React.Component {
  render() {

    const successCallback = (user) => {
      this.props.dispatch(push("/home"));
    };
   
    const errorCallback = (error) => {
      this.props.dispatch(push("/login"));
    };

    // just redirect to '/' in both cases
    return (
      <CallbackComponent 
        userManager={userManager} 
        successCallback={successCallback} 
        errorCallback={errorCallback}>
        <div className={this.props.classes.root}>
          <Typography variant="headline">Redirecting...</Typography>
        </div>
        
      </CallbackComponent>
    );
  }
}

export default connect()(withStyles(styles)(CallbackPage));


// WEBPACK FOOTER //
// ./src/containers/CallbackPage.js